package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Formation(
    val label: String,
    val school: String,
    val city: String,
    val started: String,
    val ended: String,
    val description: String,
    val fieldOfStudy: String? = null,
)